import React, { useEffect, useState, useMemo } from "react";
import { Card, CardBody, Container, Button, Input } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Row, Col } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../Components/Utils/Loader";
import { fetchAllPartner } from "../../slices/PartnerMangement/thunk";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import {
  PartnerDataModificationFunctionsForMailId,
  PartnerDataModificationFunctionsForPhoneNumber,
  formattedOrganizationFunction,
  formattedOrganizationsForDate,
  handleSelectPartner,
  partnerDataFrommTable,
  toggleSelectAllForPartner,
} from "./Constants/ModifyAddPartnerFunctions";
import { partnerListInsidePolicy } from "./Constants/PartnerInPolicyColumn";
import { filterPartnerResults } from "./Constants/ModifyFilterColumns";
import { PAGE_TITLES } from "../Common/constants";
import CommonButton from "../Utils/CommonButton";
import Stepper3 from "../Common/Stepper3";

function AddPartnerForPolicy() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const policyId = location.state?.policyId;
  const allOffers = location.state?.selectAllOffers;
  let values = location.state?.values;
  const isEdit = location.pathname.includes("update-partner-for-policy");
  const selectedOffers = location.state.selectedOffers;
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [selectAllPartners, setSelectAllPartners] = useState(false);
  const [allData, setAllData] = useState([]);
  const [selectedOnes, setSelectedOnes] = useState(false);
  const settlementPartner = useSelector(
    (state) => state.SelectedPartner.settlementPartner
  );
  useEffect(() => {
    dispatch(fetchAllPartner(setLoading));
    if (isEdit) {
      setSelectedPartners(settlementPartner);
    }
  }, [dispatch]);
  const PartnerData = useSelector((state) => state.Partner.partner);
  const formattedOrganizations = formattedOrganizationsForDate(PartnerData);
  const organizationsWithMaidIds = [];
  PartnerDataModificationFunctionsForMailId(
    PartnerData,
    organizationsWithMaidIds
  );
  const organizationsWithPhoneNum = [];
  PartnerDataModificationFunctionsForPhoneNumber(
    PartnerData,
    organizationsWithPhoneNum
  );
  const extractedIds = PartnerData.map((item) => item.id.split("/").pop());
  useEffect(() => {
    if (isEdit) {
      setAllData(
        formattedOrganizationFunction(
          formattedOrganizations,
          PartnerData,
          organizationsWithMaidIds,
          organizationsWithPhoneNum,
          extractedIds
        )
      );
    }
  }, []);
  useEffect(() => {
    if (!isEdit && formattedOrganizations.length > 0 && !allData.length) {
      setAllData(
        formattedOrganizationFunction(
          formattedOrganizations,
          PartnerData,
          organizationsWithMaidIds,
          organizationsWithPhoneNum,
          extractedIds
        )
      );
    }
  }, [
    isEdit,
    formattedOrganizations,
    allData,
    PartnerData,
    organizationsWithMaidIds,
    organizationsWithPhoneNum,
    extractedIds,
  ]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Enter" && partnerId?.length > 0) {
        e.preventDefault();
        handleSelectPartner(
          isEdit,
          partnerId,
          selectedOffers,
          policyId,
          navigate,
          toast,
          allOffers,
          selectAllPartners,
          values
        );
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [selectedPartners]);

  const columns = partnerListInsidePolicy(
    organizationsWithMaidIds,
    organizationsWithPhoneNum,
    formattedOrganizations,
    setSelectedPartners,
    selectedPartners,
    allData,
    setSelectedOnes
  );
  const partnerId = partnerDataFrommTable(selectedPartners);

  const steps = [
    {
      desc: "Select Offers",
      onClickStep: () => {
        isEdit
          ? navigate("/update-offer-for-policy", {
              state: { selectedOffers, partnerId, policyId },
            })
          : navigate("/offer-for-policy");
      },
    },
    {
      desc: "Select Partners",
      onClickStep: () => {},
    },
    {
      desc: "Preview",
      onClickStep: () => {
        handleSelectPartner(
          isEdit,
          partnerId,
          selectedOffers,
          policyId,
          navigate,
          toast,
          allOffers,
          selectAllPartners,
          values
        );
      },
    },
  ];

  filterPartnerResults(isEdit, selectedOnes, selectedPartners, allData);

  return (
    <React.Fragment>
      <div id="csms" className="page-content">
        <Container fluid>
          <BreadCrumb
            title={PAGE_TITLES.ADD_SETTLEMENT_POLICY}
            pageTitle={PAGE_TITLES.SETTLEMENT_POLICY_LIST}
          />
          <ToastContainer position="top-center" />
          <h5 className="rv-page-title p-0 pb-0">
            Add Settlement Policy - Partner List
          </h5>
          {isEdit ? null : <Stepper3 activeTab={2} steps={steps} />}
          <Row>
            <div className="d-flex flex-column justify-content-end flex-md-row me-4 pe-4 mb-3">
              <span className="me-3">Select All</span>
              <Input
                type={"checkbox"}
                checked={selectAllPartners}
                onChange={() => {
                  toggleSelectAllForPartner(
                    setSelectAllPartners,
                    selectAllPartners,
                    allData,
                    setSelectedPartners
                  );
                }}
                style={{
                  borderWidth: "2px",
                  borderColor: "#000",
                  borderRadius: "0",
                }}
              />
            </div>
            <Col lg={12}>
              <div className="listingjs-table " id="customerList">
                <div className="mb-3 mt-1 border table-responsive">
                  {loading && <Loader />}
                  {allData ? (
                    <MaterialReactTable
                      defaultColumn={{
                        minSize: 10,
                        maxSize: 9001,
                        muiTableBodyCellProps: {
                          sx: {
                            fontFamily: "Inter,sans-serif",
                          },
                        },
                        muiTableHeadCellProps: {
                          sx: {
                            fontFamily: "Inter,sans-serif",
                          },
                        },
                      }}
                      columns={columns}
                      data={allData}
                      enableColumnOrdering={false}
                      enableDensityToggle={false}
                      enableColumnActions={true}
                      enableColumnDragging={false}
                      enableTopToolbar={false}
                      getRowId={(row) => row.extractedId}
                    />
                  ) : null}
                </div>
              </div>
            </Col>
          </Row>
          <div className="d-flex justify-content-between gap-2 flex-wrap me-2 pe-1 pb-3 mb-4">
            <div className="me-auto">
              <CommonButton
                outline={true}
                className={
                  "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                color={"main-color"}
                type={"reset"}
                buttonAction={() => {
                  isEdit
                    ? navigate("/update-offer-for-policy", {
                        state: { selectedOffers, partnerId, policyId },
                      })
                    : navigate("/offer-for-policy");
                }}
                buttonText={"Back"}
                icon={
                  <i
                    className="ri-play-mini-fill label-icon align-middle fs-16 me-2"
                    style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}
                  ></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              />
            </div>
            <div className="d-flex gap-2 ms-auto">
              <CommonButton
                outline={true}
                className={
                  "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                color={"main-color"}
                type={"reset"}
                buttonAction={() => {
                  navigate("/policy");
                }}
                buttonText={"Cancel"}
                icon={
                  <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              />
              <CommonButton
                color={"main-color"}
                className={
                  "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                icon={
                  <i className="ri-play-mini-fill label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                type={"button"}
                buttonAction={() =>
                  handleSelectPartner(
                    isEdit,
                    partnerId,
                    selectedOffers,
                    policyId,
                    navigate,
                    toast,
                    allOffers,
                    selectAllPartners,
                    values
                  )
                }
                buttonText={"Next"}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}
export default AddPartnerForPolicy;
